import React from 'react'
import Link from 'gatsby-link'

import Banner from '../components/banner'
import Map from '../components/contactmap'
import Contactform from '../components/contactform'

import Sectiontitle from '../components/sectionTitle'

import revaGarewal from '../images/reva.jpg'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faPhoneSquare, faEnvelope } from '@fortawesome/fontawesome-free-solid'


const Contact = () => (
  <div>
    <Banner type="contactus" title="Contact Us" />
    <section className="page-grid">
      	<section className="container contact__content page-grid-section">
			<div className="row">
				<div className="col-md-5">
					<div className="contact__childminder">
						<img src={revaGarewal} alt="Reva Garewal" />
						<div className="text">
							<Sectiontitle title="Reva Garewal" />
							<div className="rc-copy">Registered Childminder</div>
							<div className="rc-copy">Registered ID: EY461588</div>
							
							<div className="small-text">
								<span className="phone"><FontAwesomeIcon icon={faPhoneSquare} /> 07863 337472</span>

								<span><FontAwesomeIcon icon={faEnvelope} /> revasotra@hotmail.com</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-7">
					<Contactform />
				</div>
			</div>
      	</section>
    	<Map />
    </section>
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact-us.js